export default {

    get: async ( cep ) => {
        try {
            if(cep == "") {
                throw 'Informe um cep'
            }
            cep = cep.replace(/\D/g, '');
            let validacep = /^[0-9]{8}$/;
            if(!validacep.test(cep)) {
                throw 'Informe um cep válido!'
            }
            const response = await fetch('https://viacep.com.br/ws/'+cep+'/json')
            return response.json()

        } catch(error) {
            throw error
        }
    }

}